import Id from './Id';
import Status from './Status';
import Supplier from './Supplier';
import Customer from './Customer';
import CompletedDate from './DeliveryDate';
import CreatorUser from './CreatorUser';
import Storage from './Storage';
import ReceiptNumber from './ReceiptNumber';
import NetPrice from './NetPrice';
import GrossPrice from './GrossPrice';
import Created from './Created';
import Updated from './Updated';
import CustomerOrder from './CustomerOrder';
import Invoice from './Invoice';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  Status: 'Státusz',
  Supplier: 'Szállító',
  Customer: 'Átvevő',
  Storage: 'Raktár',
  CompletedDate: 'Teljesítés dátuma',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  CustomerOrder: 'Vevői megrendelés',
  Invoice: 'Előlegszámla',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Invoice',
}, {
  value: 'CustomerOrder',
}, {
  value: 'Customer',
}, {
  value: 'Storage',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Status',
}, {
  value: 'CustomerOrder',
}, {
  value: 'Invoice',
}, {
  value: 'Customer',
}, {
  value: 'Storage',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  Status,
  Customer,
  Supplier,
  Storage,
  CompletedDate,
  Invoice,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Created,
  Updated,
  CustomerOrder,
};
